var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPage52(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 40,
    viewBox: "0 0 50 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img_321"
  }, /*#__PURE__*/React.createElement("g", {
    id: 123
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_ii_10606_3384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.86482 12.8076C8.22549 12.284 8.07125 11.3344 8.70903 10.809C8.83284 10.707 8.96187 10.6109 9.09565 10.5213C9.61009 10.1744 10.207 9.9129 10.8419 9.74582C11.4571 9.57347 12.1102 9.49557 12.7868 9.4872C13.4385 9.49323 14.0888 9.58317 14.7376 9.75704C15.5635 9.97832 16.3184 10.307 17.0076 10.7235C17.6916 11.1597 18.2509 11.6678 18.7104 12.2335C19.1451 12.8136 19.4459 13.4211 19.6274 14.0809C19.784 14.7551 19.7871 15.4514 19.5974 16.1592C19.5026 16.5131 19.3487 16.8513 19.1805 17.1645C18.9874 17.492 18.7654 17.7698 18.5147 17.9976C18.2338 18.2595 17.9097 18.4467 17.5817 18.5695C17.2995 18.6932 17.1571 19.2727 17.3747 19.4909C17.3808 19.4971 17.387 19.5033 17.3931 19.5095C17.6497 19.8101 17.8762 20.1447 18.058 20.4885C18.2097 20.8663 18.3167 21.2533 18.3792 21.6493C18.3918 22.0742 18.3651 22.4885 18.2545 22.9015C18.0332 23.7273 17.6665 24.3877 17.144 24.9221C16.6215 25.4565 16.0073 25.8609 15.3015 26.1354C14.5814 26.385 13.7892 26.51 12.9395 26.5352C12.0754 26.5354 11.1982 26.4269 10.3134 26.1898C9.68422 26.0212 9.09575 25.7792 8.49815 25.4926C7.88616 25.1811 7.33457 24.8015 6.85778 24.3787C6.34693 23.9257 5.9358 23.4151 5.60474 22.8417C5.50242 22.6645 5.41011 22.4844 5.32938 22.2997C4.99576 21.5363 5.59952 20.7733 6.42073 20.6331L7.04123 20.5271C7.98734 20.3655 8.83561 21.1588 9.51861 21.8331C9.52473 21.8392 9.5309 21.8452 9.5371 21.8512C9.96403 22.3028 10.4921 22.6129 11.141 22.7867C11.4556 22.871 11.7558 22.9304 12.0915 22.936C12.3969 22.9757 12.6986 22.9512 12.9911 22.882C13.2586 22.8273 13.5223 22.7083 13.7376 22.5341C13.9279 22.3744 14.0751 22.1398 14.1593 21.8252C14.2542 21.4713 14.2349 21.15 14.1408 20.8719C14.0371 20.6421 13.8955 20.4341 13.7195 20.235C13.6672 20.1758 13.6086 20.1227 13.5455 20.0753C13.3272 19.9113 13.0893 19.7603 12.8284 19.6351C12.485 19.501 12.181 19.3774 11.8663 19.2931L11.768 19.2667C10.9427 19.0456 10.4529 18.1973 10.6741 17.3719C10.8952 16.5466 11.7436 16.0569 12.5689 16.278L12.6672 16.3043C12.9228 16.3728 13.2033 16.4269 13.4944 16.4417C13.7802 16.4761 14.0569 16.466 14.3298 16.3916C14.5777 16.3315 14.7968 16.2217 15.012 16.0475C15.2024 15.8878 15.3548 15.6336 15.4443 15.2993C15.5181 15.024 15.5223 14.7723 15.4623 14.5244C15.3774 14.2909 15.2425 14.0861 15.0828 13.8958C14.8981 13.7199 14.6885 13.5583 14.454 13.4112C14.1945 13.2785 13.9298 13.1654 13.6545 13.0916C13.1039 12.9441 12.5453 12.9841 12.0087 13.1775C11.9665 13.1931 11.9248 13.2096 11.8838 13.227C11.0526 13.5788 10.035 13.7658 9.33667 13.1939L8.86482 12.8076Z",
    fill: "#95CD0B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    filter: "url(#filter1_ii_10606_3384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0815 23.7749C28.9463 22.9822 29.608 22.2032 30.0855 21.4162C30.5238 20.6523 30.7414 19.944 30.6977 19.294C30.684 19.0909 30.627 18.8499 30.57 18.6089C30.4737 18.391 30.3571 18.1744 30.2216 17.9795C30.0468 17.8076 29.8531 17.6574 29.6012 17.552C29.3493 17.4465 29.0405 17.4061 28.6749 17.4307C27.172 17.5317 26.1367 18.5195 25.607 20.3505L22.2642 18.882C22.4181 18.1371 22.6994 17.4653 23.108 16.8666C23.4962 16.2692 23.9726 15.7679 24.5546 15.3207C25.0987 14.9169 25.7498 14.5875 26.4673 14.3352C27.1659 14.1046 27.9119 13.9728 28.7243 13.9181C29.5584 13.8824 30.3601 13.9713 31.109 14.1862C31.839 14.4227 32.4932 14.7459 33.0541 15.1979C33.6149 15.6498 34.0608 16.2115 34.4105 16.8612C34.7413 17.5327 34.9354 18.2949 34.9697 19.1087C34.9701 19.7207 34.9054 20.2759 34.7378 20.8177C34.5513 21.3811 34.3011 21.908 34.0089 22.4173C33.6978 22.9483 33.3433 23.4414 32.9265 23.9182C32.5111 24.4154 32.0524 24.8747 31.5922 25.3137L29.8261 26.9627L36.1021 26.5406L36.3357 30.0137L23.5198 30.8757L23.3367 28.1541L28.0815 23.7749Z",
    fill: "#DE6969"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    filter: "url(#filter2_ii_10606_3384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.3281 11.612C38.3281 10.7217 39.0498 10 39.9401 10H43.393C44.2833 10 45.005 10.7217 45.005 11.612V24.612C45.005 25.5023 44.2833 26.224 43.393 26.224H42.3829C41.4926 26.224 40.7709 25.5023 40.7709 24.612V14.7227C40.7709 14.0481 40.2241 13.5013 39.5495 13.5013C38.875 13.5013 38.3281 12.9545 38.3281 12.2799V11.612Z",
    fill: "#FFB800"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_10606_3384",
    x: 4.42839,
    y: 8.68034,
    width: 16.1198,
    height: 18.6608,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.805985,
    dy: -0.805985
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.805985
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "color-burn",
    in2: "shape",
    result: "effect1_innerShadow_10606_3384"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.805985,
    dy: 0.805985
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.805985
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_10606_3384",
    result: "effect2_innerShadow_10606_3384"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_10606_3384",
    x: 21.4596,
    y: 13.1042,
    width: 15.6823,
    height: 18.5768,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.805985,
    dy: -0.805985
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.805985
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "color-burn",
    in2: "shape",
    result: "effect1_innerShadow_10606_3384"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.805985,
    dy: 0.805985
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.805985
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_10606_3384",
    result: "effect2_innerShadow_10606_3384"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_10606_3384",
    x: 37.5221,
    y: 9.19402,
    width: 8.28775,
    height: 17.8366,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.805985,
    dy: -0.805985
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.805985
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "color-burn",
    in2: "shape",
    result: "effect1_innerShadow_10606_3384"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.805985,
    dy: 0.805985
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.805985
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_10606_3384",
    result: "effect2_innerShadow_10606_3384"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage52);
export default __webpack_public_path__ + "static/media/page5_2.ff2da3acd1e1f231d1b6dd85d1cdb45c.svg";
export { ForwardRef as ReactComponent };